export function NotFound() {
  return (
    <div>
      <h2 className="font-semibold text-2xl p-6">404</h2>
    </div>
  );
}
